export default __webpack_public_path__ + "static/media/project3.3654592a.PNG";